import { Routes, Route, Navigate } from "react-router-dom";
import { MainPage, PatientProfilePage, ProfilePage } from "../pages";

export const DoctorRoute = () => {
  return (
    <Routes>
      <Route path="doctor/main" element={<MainPage />} />
      <Route path="doctor/patient-profile" element={<PatientProfilePage />} />
      <Route path="doctor/profile" element={<ProfilePage />} />
      <Route path="/*" element={<Navigate to={"doctor/main"} />} />
    </Routes>
  );
};
